/**
 * Auth Mutations - Vuex Store Mutations (TypeScript)
 *
 * Handles synchronous state updates for authentication data
 */

export interface AuthState {
  userId: string | null;
  name: string | null;
  lastName: string | null;
  email: string | null;
  role: string | null;
  token: string | null;
}

export const initialAuthState = (): AuthState => ({
  userId: null,
  name: null,
  lastName: null,
  email: null,
  role: null,
  token: null,
});

export default {
  /**
   * Update user authentication data
   * Merges provided fields with existing state
   */
  setUser(state: AuthState, payload: Partial<AuthState>): void {
    state.userId = payload.userId ?? state.userId;
    state.email = payload.email ?? state.email;
    state.name = payload.name ?? state.name;
    state.lastName = payload.lastName ?? state.lastName;
    state.role = payload.role ?? state.role;
    state.token = payload.token ?? state.token;
  },
};


